import { updateObject } from "../../../../shared";
import {
  globalConstants,
  PAGINATION_DEFAULTS,
  googleSocialLinkConstants,
} from "../../constants";

const { SUCCESS } = globalConstants;
const { STORE_DATA } = googleSocialLinkConstants;

//Default state of google social link reducer
const initialState = {
  brandLocationsData: [],
  brandLocationsPaginationData: {
    ...PAGINATION_DEFAULTS,
  },
};

//Manipulating the state of google social link based on actions and returning the state
export const googleSocialLinkReducer = (state = initialState, action) => {
  if (action.type === STORE_DATA + SUCCESS) {
    return updateObject(state, {
      brandLocationsData: action.data.data,
      brandLocationsPaginationData: action.data.page,
    });
  } else {
    return state;
  }
};
